import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { ValuationService } from '../services/valuation.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuardService  {
  constructor(
    public router: Router,
    public auth: AuthenticationService,
    public route: ActivatedRoute,
    private readonly valuationService: ValuationService,
  ) { }
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return true;
    /*  // Custom route checks for pages
      if (this.auth.checkLoginState() == true) {
        // Logged in 
        this.checkVerifiedState(state);
        return true;
      } else {
        // Logged out 
        this.checkVerifiedState(state);
        return true;
      }
  
      /*
    } else {
      // Checkes for "normal" pages
      if (state.url == localStorage.getItem('state')) {
        return true;
      } else {
        if (state.url != localStorage.getItem('state')) {
          if(localStorage.getItem('state') == null) {
            return true;
          } else {
            this.router.navigate([localStorage.getItem('state')]);
          }
        } else {
          return true;
        }
      }
    }*/
  }

  private checkVerifiedState(state: RouterStateSnapshot) {
    if (localStorage.getItem('verified')) {
      if (localStorage.getItem('verified') == "true") {
        if (state.url != "/informatie-aanleveren") {
          this.router.navigate(['/informatie-aanleveren']);
        }
        localStorage.setItem('verified', "true");
      } else {
        if (state.url != "/verificatie") {
          this.router.navigate(['/verificatie']);
        }
        localStorage.removeItem('verified');
      }
    } else {
      if (state.url != "/verificatie") {
        this.router.navigate(['/verificatie']);
      }
      localStorage.setItem('verified', "true");
    }
  }
}
